export class ValidationErrorCodes {

    static readonly NumberOutOfRange = 'VALIDATION_ERROR_NUMBER_OUT_OF_RANGE';
    static readonly NumberMustBeGreater = 'VALIDATION_ERROR_NUMBER_MUST_BE_GREATER';
    static readonly NumberMustBeLess = 'VALIDATION_ERROR_NUMBER_MUST_BE_LESS';
    
    static readonly IsRequired = 'VALIDATION_ERROR_IS_REQUIRED';
}